/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateCampaignsMetadataRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {UpdateCampaignsMetadataResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const updateCampaignsMetadata = (request: UpdateCampaignsMetadataRequest, options?: CashRequestOptions) => post<UpdateCampaignsMetadataRequest, UpdateCampaignsMetadataResponse>("/2.0/cash/update-campaigns-metadata", request, {...options, rejectOnError: true })